import { useState, useEffect } from 'react';
import { AssignableUser } from '$/core/models';
import { UserAdminService } from '$/services/UserAdminService';

/**
 * Fetches a fresh assignees list whenever the modal opens.
 * Seeds from `initialList` so the dropdown is never empty while the request is in flight.
 */
export function useAssignees(isOpen: boolean, initialList?: AssignableUser[]) {
  const [assignees, setAssignees] = useState<AssignableUser[]>(initialList ?? []);
  const [isLoadingAssignees, setIsLoadingAssignees] = useState(false);

  useEffect(() => {
    if (!isOpen) return;

    let cancelled = false;
    setIsLoadingAssignees(true);

    UserAdminService.getAssignees()
      .then(fresh => {
        if (!cancelled) setAssignees(fresh);
      })
      .catch(() => {
        // Silently fall back to the last-known initialList on error
      })
      .finally(() => {
        if (!cancelled) setIsLoadingAssignees(false);
      });

    return () => {
      cancelled = true;
    };
  }, [isOpen]);

  return { assignees, isLoadingAssignees };
}
